import * as fromSelfEnroll from '../self-enrollment/store/SelfEnroll.reducer';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
  SelfEnroll: fromSelfEnroll.State;
}

export const reducers: ActionReducerMap<AppState> = {
  SelfEnroll: fromSelfEnroll.SelfEnrollReducer
};
